<template>
  <b-row>
    <b-col cols="12" md="6">
      <form-field-input
        v-for="field in leftColumnFields"
        :key="field.key"
        :field="field"
        :formConfig="formConfig"
        :input="input"
        @input="handleFieldInput"
      />
    </b-col>
    <b-col cols="12" md="6">
      <form-field-input
        v-for="field in rightColumnFields"
        :key="field.key"
        :field="field"
        :formConfig="formConfig"
        :input="input"
        @input="handleFieldInput"
      />
    </b-col>
  </b-row>
</template>

<script>
import moduleCommonMixin from "./moduleCommonMixin";

export default {
  mixins: [moduleCommonMixin],
  props: {
    formConfig: {
      type: Object,
      required: true,
    },
    formModule: {
      type: Object,
      required: true,
    },
    input: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    visibleFields() {
      return this.formModule.fields.filter(
        (x) => x.isVisible && x.key !== "ConfirmEmail"
      );
    },
    confirmEmailField() {
      return this.formModule.fields.find((x) => x.key === "ConfirmEmail");
    },
    splitIndex() {
      return Math.ceil(this.visibleFields.length / 2);
    },
    leftColumnFields() {
      const fields = this.visibleFields.slice(0, this.splitIndex);
      return this.injectConfirmEmail(fields);
    },
    rightColumnFields() {
      const fields = this.visibleFields.slice(this.splitIndex);
      return this.injectConfirmEmail(fields);
    },
  },
  methods: {
    injectConfirmEmail(columnFields) {
      if (!this.confirmEmailField || !this.confirmEmailField.isVisible) {
        return columnFields;
      }

      const emailIndex = columnFields.findIndex((x) => x.type === "Email");

      if (emailIndex !== -1) {
        const newFields = [...columnFields];
        newFields.splice(emailIndex + 1, 0, this.confirmEmailField);
        return newFields;
      }

      return columnFields;
    },
  },
};
</script>
